import { DayOfWeek, TimeOfDay } from '@src/lib/__generated/api';

export const timeOfDayItems: { label: TimeOfDay | 'ALL'; value: TimeOfDay | '' }[] = [
	{ label: 'ALL', value: '' },
	{ label: TimeOfDay.AM, value: TimeOfDay.AM },
	{ label: TimeOfDay.PM, value: TimeOfDay.PM },
];

export const weekDaysItems: {
	label: DayOfWeek[0];
	value: DayOfWeek;
}[] = [
	{ label: DayOfWeek.Monday[0], value: DayOfWeek.Monday },
	{ label: DayOfWeek.Tuesday[0], value: DayOfWeek.Tuesday },
	{ label: DayOfWeek.Wednesday[0], value: DayOfWeek.Wednesday },
	{ label: DayOfWeek.Thursday[0], value: DayOfWeek.Thursday },
	{ label: DayOfWeek.Friday[0], value: DayOfWeek.Friday },
	{ label: DayOfWeek.Saturday[0], value: DayOfWeek.Saturday },
];

export const weekDaysItemsES: {
	label: DayOfWeek[0];
	value: DayOfWeek;
}[] = [
	{ label: 'L', value: DayOfWeek.Monday },
	{ label: 'M', value: DayOfWeek.Tuesday },
	{ label: 'M', value: DayOfWeek.Wednesday },
	{ label: 'J', value: DayOfWeek.Thursday },
	{ label: 'V', value: DayOfWeek.Friday },
	{ label: 'S', value: DayOfWeek.Saturday },
];
